var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "43px",
    height: "89px",
    viewBox: "0 0 43 89",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-symbol") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing-Page",
    transform: "translate(-127.000000, -74.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "symbol",
    transform: "translate(127.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tentacles",
    transform: "translate(3.863453, 54.971157)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.31914564,0 L8.31914564,12.6759251 C8.31914564,18.2650218 6.98808234,19.9254783 3.99318991,19.9254783 C0.998297477,19.9254783 0,17.240105 0,14.9299948",
    id: "Stroke-1",
    stroke: "#FE8438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6415715,0 L14.6415715,24.2991208 C14.6415715,29.8882174 13.3105082,31.548674 10.3156158,31.548674 C7.32072338,31.548674 6.3224259,28.8633006 6.3224259,26.5531905",
    id: "Stroke-3",
    stroke: "#ED0D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9642054,0 L20.9642054,17.6572947 C20.9642054,23.2463913 22.2952687,24.9068479 25.2901612,24.9068479 C28.2850536,24.9068479 29.2833511,22.2214745 29.2833511,19.9113644",
    id: "Stroke-5",
    stroke: "#A307B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2868393,0 L27.2868393,4.37364248 C27.2868393,9.96273914 28.6179026,11.6231957 31.612795,11.6231957 C34.6076875,11.6231957 35.6059849,8.93782236 35.6059849,6.62771222",
    id: "Stroke-7",
    stroke: "#57E5D4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "head"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,31.9604672 C0,31.9604672 2.53234793,24.4186736 8.26715098,15.4156784 C14.3858826,5.81118272 21.5,0 21.5,0 C21.5,0 28.4880823,5.82156057 34.499081,15.5327406 C39.9456257,24.3319148 43,31.9604672 43,31.9604672 L35.0069649,35.9455628 L35.0069649,48.8373473 L7.85660115,48.8373473 L7.85660115,35.9455628 L0,31.9604672 Z",
    id: "Fill-21",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.5,
    y1: 42.6835294,
    x2: 21.5,
    y2: 32.7207902,
    id: "Stroke-23",
    stroke: "#30A6FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.4914874,
    y1: 37.7023673,
    x2: 16.5085126,
    y2: 37.7023673,
    id: "Stroke-25",
    stroke: "#30A6FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c732e8d6bdbcd8bd27d34234c4067401.svg";
export { ForwardRef as ReactComponent };